import MultilaneIndicator from './MultilaneIndicator'

export default MultilaneIndicator



// WEBPACK FOOTER //
// ./src/legacy/components/MultilaneIndicator/index.js